import { FC } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface BlockUserDialogProps {
    open: boolean;
    user: string;
    isBanned: boolean;
    onAcceptEvent: () => void;
    onDismiss: () => void;
}

const BlockUserDialog: FC<BlockUserDialogProps> = ({ open, onAcceptEvent, onDismiss, user, isBanned }) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onDismiss}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle>{isBanned ? t('Unblock User') : t('Block User')}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <Typography>
                        {isBanned
                            ? t('Do you want to unblock {{username}}?', { username: user })
                            : t(
                                  'Are you sure you want to block {{username}} and remove all his messages in the event?',
                                  { username: user },
                              )}
                    </Typography>
                    <Typography>
                        {isBanned
                            ? t(
                                  'That will allow {{username}} to send messages again but all his messages will remain removed',
                                  {
                                      username: user,
                                  },
                              )
                            : t(
                                  'You can unblock {{username}} again but all his messages will remain removed',
                                  {
                                      username: user,
                                  },
                              )}
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onAcceptEvent}>
                    {isBanned ? t('Unblock this user') : t('Block this user')}
                </Button>
                <Button onClick={onDismiss} autoFocus>
                    {t('Cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BlockUserDialog;
